import FanAPI from 'watch-fanapi';
import fanSelector from 'common/selectors/fanSelector';
import { checkSWIDAuthentication } from 'common/actions/oneIdActions';
import { isEmpty } from 'lib/util';
import * as perf from 'lib/util/perf';

export const START_GET_FAN = 'START_GET_FAN';
export const COMPLETE_GET_FAN = 'COMPLETE_GET_FAN';

const fanApi = new FanAPI({ sourceHeader: 'espncom-watch' });

export function startGetFan() {
    return {
        type: START_GET_FAN,
        startTime: Date.now()
    };
}

export function completeGetFan(fan) {
    return {
        type: COMPLETE_GET_FAN,
        completeTime: Date.now(),
        fan
    };
}

export function getFan(swid) {
    return (dispatch) => {
        dispatch(startGetFan());
        return fanApi.getFanForId(swid).then((fan) => {
            dispatch(completeGetFan(fan));
            return fan;
        }).catch(() => {
            dispatch(completeGetFan({}));
            return {};
        });
    };
}

export function createSmartFanAction() {
    return async (dispatch, getState) => {
        perf.markStart('createSmartFanAction');
        let fan = fanSelector(getState());
        if (isEmpty(fan)) {
            let { oneId: { isLoggedIn } = {} } = getState();
            if (!isLoggedIn) {
                isLoggedIn = await dispatch(checkSWIDAuthentication());
            }

            if (isLoggedIn) {
                const { oneId: { swid } = {} } = getState();
                fan = await dispatch(getFan(swid));
            }
        }
        perf.measureAndTime('createSmartFanAction');
        return fan;
    };
}

/**
 Update the "uid" in the preferences for this fan to test scoring
 */
//  const myFan = {
//    "id":"{AEDB5BCC-173D-49BD-9B0B-77DFD5964C19}",
//    "profile":{
//       "createDate":1422286205898,
//       "lastUpdateDate":1502446881443,
//       "lastUpdateSource":"fuse-v2-batch",
//       "isInsider":true,
//       "gender":"M",
//       "hasNotificationPreferences":false,
//       "useSortGlobal":true,
//       "age":30,
//       "countryCode":"US",
//       "postalCode":"11501",
//       "dmaId":"501",
//       "registrationSource":"espn_video",
//       "registrationDate":1271055600000
//    },
//    "lastAccessDate":"2017-08-11T18:56:19Z",
//    "createDate":"2010-07-21T02:33:45Z",
//    "lastUpdateDate":"2017-08-11T22:23:27Z",
//    "createSource":null,
//    "lastUpdateSource":"ESPN.com - FAM",
//    "lastAccessSource":"ESPN.com - FAM",
//    "preferences":[
//        {
//             "id": "14315045-A46A-478F-BEAE-8ACD3F36B8CD",
//             "createDate": 1502490872419,
//             "createSource": "ESPN.com - FAM",
//             "metaData": {
//                 "sportId": "54",
//                 "teamId": "251",
//                 "team": {
//                     "uid": "s:600~l:602"
//                 }
//             },
//             "sortGlobal": 109
//        }
//    ]
// };



// WEBPACK FOOTER //
// ./app/common/actions/fanActions.js